import classNames from "classnames";
import {ButtonType} from "./types";

export const getCssClasses = (buttonProps: ButtonType) => {
  if (buttonProps.looksLikeLink) {
    return classNames("svv-button--looks-like-link",
      {
        "svv-button--looks-like-link--has-icon": buttonProps.icon,
        "svv-button--icon-right": buttonProps.iconPlacement === "right",
      })
  } 
    return classNames("svv-button", {
      "svv-button--small": buttonProps.small,
      "svv-button--secondary": buttonProps.color === "secondary",
      "svv-button--disabled": buttonProps.disabled,
      "svv-button--loading": buttonProps.loading,
      "svv-button--icon": !!buttonProps.icon,
      "svv-button--icon-right": buttonProps.iconPlacement === "right",
    }, buttonProps.className)
  
};

export const getButtonType = (buttonProps: ButtonType): "submit"|"reset"|"button"|undefined => {
  let buttonType: "submit"|"reset"|"button"|undefined

  switch (buttonProps.type) {
    case "submit":
    case "reset":
      buttonType = buttonProps.type
      break
    default:
      buttonType = "button"
  }

  return buttonType
}
